import moment from 'moment';
import i18n from '@/i18n';
import md5 from 'md5';

moment.locale(i18n.locale);

export default {
  computed: {
    isMobile() {
      return this.isMobileScreen();
    },
  },
  methods: {
    isMobileScreen() {
      return (window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) <= 850;
    },
    getGravatarURL(email) {
      return `https://s.gravatar.com/avatar/${md5(email)}?s=150&d=404`;
    },
    validateEmail(email) {
      const cleanEmail = email.toLowerCase().trim();
      return cleanEmail.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    checkGravatar(email) {
      if (this.validateEmail(email)) {
        const xhr = new XMLHttpRequest();
        xhr.open('HEAD', this.getGravatarURL(email), false);
        xhr.send();
        if (xhr.status !== 200) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
